module.exports = __webpack_public_path__ + "static/img/wangdai.0b71d42b.png";